import { Button, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { FC } from 'react';
import ArrowBackground from 'v2/assets/vector/ArrowBackground';

interface Props {
  onRetry: () => void;
}

const SomethingWentWrong: FC<Props> = ({ onRetry }) => {
  const { translation } = useTranslation();

  return (
    <Stack alignItems="center" justifyContent="center" gap={3} sx={{ height: 'calc(100vh - 160px)' }}>
      <ArrowBackground sx={{ position: 'fixed', right: 0, bottom: 0, width: '15vw', height: 'auto', zIndex: -1 }} />
      <Stack alignItems="center" gap={1} maxWidth="600px">
        <Typography variant="h5" color="primary">
          {translation.something_went_wrong}
        </Typography>
        <Typography color="textSecondary" textAlign="center" sx={{ whiteSpace: 'pre-line' }}>
          {translation.something_went_wrong_description}
        </Typography>
      </Stack>
      <Button id="retry-button" variant="contained" color="primary" onClick={onRetry}>
        {translation.retry}
      </Button>
    </Stack>
  );
};

export default SomethingWentWrong;
